import { useState } from 'react';

export default function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      name: 'María González',
      role: 'Paciente de Terapia Individual',
      image: 'https://public.readdy.ai/ai/img_res/705a8ceb7d6d89a68d097d2f54128b93.jpg',
      text: 'Adriana me ayudó a superar mi ansiedad y recuperar mi confianza. Su enfoque empático y profesional hizo toda la diferencia. Ahora me siento más fuerte y capaz de enfrentar cualquier desafío.',
      rating: 5
    },
    {
      name: 'Carlos y Ana Martínez',
      role: 'Pareja en Terapia',
      image: 'https://readdy.ai/api/search-image?query=Happy%20couple%20portrait%20smiling%20together%20in%20natural%20lighting%20with%20neutral%20beige%20background%20showing%20genuine%20connection%20and%20love%20after%20successful%20couples%20therapy%20representing%20relationship%20healing%20and%20emotional%20bonding%20with%20warm%20authentic%20expressions&width=400&height=400&seq=testimonial002&orientation=squarish',
      text: 'Nuestra relación estaba pasando por un momento difícil. Gracias a las sesiones con Adriana, aprendimos a comunicarnos mejor y fortalecimos nuestro vínculo. Estamos muy agradecidos.',
      rating: 5
    },
    {
      name: 'Laura Fernández',
      role: 'Coaching Profesional',
      image: 'https://readdy.ai/api/search-image?query=Professional%20businesswoman%20portrait%20confident%20and%20successful%20in%20her%20forties%20with%20warm%20smile%20natural%20lighting%20and%20neutral%20beige%20background%20representing%20career%20growth%20and%20professional%20development%20after%20coaching%20with%20authentic%20expression%20of%20achievement&width=400&height=400&seq=testimonial003&orientation=squarish',
      text: 'El coaching con Adriana transformó mi carrera profesional. Me ayudó a superar mis miedos y alcanzar mis metas. Su guía fue fundamental para mi crecimiento personal y profesional.',
      rating: 5
    },
    {
      name: 'Roberto Sánchez',
      role: 'Manejo de Crisis',
      image: 'https://readdy.ai/api/search-image?query=Portrait%20of%20a%20resilient%20man%20in%20his%20forties%20with%20peaceful%20expression%20natural%20lighting%20and%20neutral%20beige%20background%20representing%20emotional%20recovery%20and%20healing%20after%20crisis%20intervention%20therapy%20with%20genuine%20look%20of%20hope%20and%20strength&width=400&height=400&seq=testimonial004&orientation=squarish',
      text: 'Pasé por un momento muy difícil en mi vida. Adriana estuvo ahí para mí, brindándome el apoyo que necesitaba. Su profesionalismo y calidez humana me ayudaron a salir adelante.',
      rating: 5
    },
    {
      name: 'Patricia Ruiz',
      role: 'Bienestar Emocional',
      image: 'https://readdy.ai/api/search-image?query=Serene%20woman%20portrait%20in%20her%20fifties%20with%20peaceful%20smile%20natural%20lighting%20and%20neutral%20beige%20background%20representing%20emotional%20wellness%20and%20mental%20health%20balance%20after%20therapy%20with%20genuine%20expression%20of%20inner%20peace%20and%20contentment&width=400&height=400&seq=testimonial005&orientation=squarish',
      text: 'Las herramientas que aprendí con Adriana me han ayudado a manejar el estrés diario y encontrar equilibrio en mi vida. Me siento más tranquila y en paz conmigo misma.',
      rating: 5
    },
    {
      name: 'Familia Torres',
      role: 'Orientación Familiar',
      image: 'https://readdy.ai/api/search-image?query=Happy%20family%20portrait%20with%20parents%20and%20children%20smiling%20together%20in%20natural%20lighting%20with%20neutral%20beige%20background%20showing%20harmony%20and%20love%20after%20family%20counseling%20representing%20healthy%20family%20dynamics%20and%20emotional%20connection&width=400&height=400&seq=testimonial006&orientation=squarish',
      text: 'Adriana nos ayudó a mejorar la comunicación en nuestra familia. Ahora entendemos mejor las necesidades de cada uno y hemos creado un ambiente más armonioso en casa.',
      rating: 5
    }
  ];

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonios" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4 font-['Playfair_Display']">
            Lo Que Dicen Mis Pacientes
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Testimonios reales de personas que han transformado sus vidas
          </p>
        </div>

        {/* Main Testimonial */}
        <div className="max-w-4xl mx-auto mb-12">
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-3xl p-8 md:p-12 shadow-lg">
            <div className="flex flex-col md:flex-row items-center gap-8">
              <div className="w-32 h-32 flex-shrink-0">
                <img 
                  src={testimonials[activeIndex].image}
                  alt={testimonials[activeIndex].name}
                  className="w-full h-full object-cover object-top rounded-full shadow-md"
                />
              </div>
              <div className="flex-1 text-center md:text-left">
                <div className="flex justify-center md:justify-start gap-1 mb-4">
                  {[...Array(testimonials[activeIndex].rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-2xl text-yellow-400"></i>
                  ))}
                </div>
                <p className="text-lg text-gray-700 mb-6 leading-relaxed italic">
                  "{testimonials[activeIndex].text}"
                </p>
                <div>
                  <h4 className="text-xl font-semibold text-gray-900 font-['Playfair_Display']">
                    {testimonials[activeIndex].name}
                  </h4>
                  <p className="text-sm text-gray-600">{testimonials[activeIndex].role}</p>
                </div>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div className="flex justify-center items-center gap-4 mt-8">
            <button
              onClick={prevTestimonial}
              className="w-12 h-12 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-full transition-colors cursor-pointer"
              aria-label="Testimonio anterior"
            >
              <i className="ri-arrow-left-s-line text-2xl text-gray-700"></i>
            </button>
            <div className="flex gap-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveIndex(index)}
                  className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${
                    index === activeIndex ? 'bg-[#14B8A6] w-8' : 'bg-gray-300'
                  }`}
                  aria-label={`Ir al testimonio ${index + 1}`}
                />
              ))}
            </div>
            <button
              onClick={nextTestimonial}
              className="w-12 h-12 flex items-center justify-center bg-gray-100 hover:bg-gray-200 rounded-full transition-colors cursor-pointer"
              aria-label="Siguiente testimonio"
            >
              <i className="ri-arrow-right-s-line text-2xl text-gray-700"></i>
            </button>
          </div>
        </div>

        {/* All Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              onClick={() => setActiveIndex(index)}
              className={`bg-white rounded-2xl p-6 shadow-sm hover:shadow-lg transition-all cursor-pointer border-2 ${
                index === activeIndex ? 'border-[#14B8A6]' : 'border-transparent'
              }`}
            >
              <div className="flex items-center gap-4 mb-4">
                <div className="w-16 h-16 flex-shrink-0">
                  <img 
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top rounded-full"
                  />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-900 text-sm">{testimonial.name}</h4>
                  <p className="text-xs text-gray-600">{testimonial.role}</p>
                </div>
              </div>
              <div className="flex gap-1 mb-3">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-base text-yellow-400"></i>
                ))}
              </div>
              <p className="text-sm text-gray-700 leading-relaxed line-clamp-4">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
